import { render, staticRenderFns } from "./CoalEquipMonitor.vue?vue&type=template&id=27136c4a&scoped=true&"
import script from "./CoalEquipMonitor.vue?vue&type=script&lang=js&"
export * from "./CoalEquipMonitor.vue?vue&type=script&lang=js&"
import style0 from "./CoalEquipMonitor.vue?vue&type=style&index=0&id=27136c4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27136c4a",
  null
  
)

export default component.exports